import React, { useState, useEffect, useCallback } from 'react';
import {
  FaCalendarAlt, FaClock, FaArrowLeft, FaArrowRight, FaUser, FaStar, FaTimes, FaExclamationTriangle, FaVideo, FaExclamationCircle, FaPhone,
  FaLinkedinIn,
  FaChevronLeft,
  FaChevronRight,
  FaSortAmountUp, FaSortAmountDown,
  FaMapMarkerAlt,
  FaEllipsisV,
  FaHome, FaCheckCircle, FaChartLine, FaList, FaInfoCircle, FaClipboardCheck, FaTasks, FaUserShield, FaStopwatch, FaNewspaper, FaChalkboardTeacher, FaQuestionCircle
} from 'react-icons/fa';
import { Modal, Button, Form, Badge, Card, Dropdown, Row, Col, Alert } from 'react-bootstrap';
import moment from 'moment';
import 'moment/locale/fr';
import Sidebar from '../dashboard/sidebar';
import Navbar from '../dashboard/navbar';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CustomCalendar from '../RDV/calendrier';
import useAuth from '../dashboard/useAuth';
import { getAuthToken } from '../../authToken';


const PriseRendezVousClient = () => {
  useAuth();
  const user_id = localStorage.getItem('user_id');
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [selectedDate, setSelectedDate] = useState(moment());
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [availableBookings, setAvailableBookings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [alert, setAlert] = useState({ message: '', type: '' });
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);



  const location = useLocation();
  const navigate = useNavigate();
  const { user, titre } = location.state || {};
  const [userData, setUserData] = useState({});
  const [statutEligibilite, setStatutEligibilite] = useState({});
  const [nbreSimulation, setNbreSimulation] = useState({ simulation_count: 0, total_questions: 0, favoris_questions: 0 });
  const [nbreQuiz, setNbreQuiz] = useState({ question_count: 0 });
  const [nbreEtude, setNbreEtude] = useState({ etude_cas_count: 0 });
  const [nbreExamen, setNbreExamen] = useState({ "En cours de validation": 0, "Approuve": 0, "Termine": 0 });
  const [formation, setFormation] = useState([]);
  const [donneParcours, setDonneParcours] = useState([]);
  const accesGroupe = localStorage.getItem('accesGroupe');
  const [submittingBookings, setSubmittingBookings] = useState({});

  const userHasAccess = (accessKey) => {
    return accesGroupe && accesGroupe.includes(accessKey);
  };

  // Couleurs sobres et professionnelles
  const cardStyles = {
    parcours: { bg: '#f8f9fa', border: '#e9ecef', icon: FaChartLine, color: '#495057' },
    eligibilite: { bg: '#f8f9fa', border: '#e9ecef', icon: FaUserShield, color: '#495057' },
    simulation: { bg: '#f8f9fa', border: '#e9ecef', icon: FaStopwatch, color: '#495057' },
    examen: { bg: '#f8f9fa', border: '#e9ecef', icon: FaNewspaper, color: '#495057' },
    quiz: { bg: '#f8f9fa', border: '#e9ecef', icon: FaQuestionCircle, color: '#495057' },
    etude: { bg: '#f8f9fa', border: '#e9ecef', icon: FaChalkboardTeacher, color: '#495057' }
  };

  const getStatusColor = (statut) => {
    switch (statut) {
      case "valide": return "#28a745";
      case "en attente": return "#ffc107";
      case "a revoir": return "#dc3545";
      default: return "#6c757d";
    }
  };

  const getStatusIcon = (statut) => {
    switch (statut) {
      case "valide": return <FaCheckCircle size={18} className="text-success" />;
      case "en attente": return <FaClock size={18} className="text-warning" />;
      case "a revoir": return <FaExclamationTriangle size={18} className="text-danger" />;
      default: return null;
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
                method: 'get',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
        const data = await response.json();
        if (response.ok) setUserData(data);
      } catch (error) {
        console.error('Erreur lors de la récupération des données utilisateur:', error);
      }
    };

    const fetchFormData = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-eligibilite-pour-admin/${user_id}/`);
        const data = await response.json();
        if (response.ok) setStatutEligibilite(data);
      } catch (error) { }
    };

    const fetchNbreSimulation = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_HOTE + `/nbre-simulation/${user_id}/`);
        const data = await response.json();
        if (response.ok) setNbreSimulation(data);
      } catch (error) {
        console.error("Erreur lors de la récupération du nombre de simulations:", error);
      }
    };

    const fetchNbreQuiz = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_HOTE + `/nbre-quiz/${user_id}/`);
        const data = await response.json();
        if (response.ok) setNbreQuiz(data);
      } catch (error) {
        console.error("Erreur lors de la récupération du nombre de quiz:", error);
      }
    };

    const fetchNbreEtude = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_HOTE + `/nbre-etude-cas/${user_id}/`);
        const data = await response.json();
        if (response.ok) setNbreEtude(data);
      } catch (error) {
        console.error("Erreur lors de la récupération du nombre d'études de cas:", error);
      }
    };

    const fetchNbreExamen = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_HOTE + `/nbre-examen/${user_id}/`);
        const data = await response.json();
        if (response.ok) setNbreExamen(data);
      } catch (error) {
        console.error("Erreur lors de la récupération du nombre d'examens:", error);
      }
    };

    const fetchParcours = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-donnee-parcours-utilisateur/${user_id}/`);
        if (response.ok) {
          const data = await response.json();
          setDonneParcours(data.parcours);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des parcours:", error);
      }
    };

    fetchUserData();
    fetchFormData();
    fetchNbreSimulation();
    fetchNbreQuiz();
    fetchNbreEtude();
    fetchNbreExamen();
    fetchParcours();
  }, [user_id]);

  useEffect(() => {
    if (user_id) {
      document.title = "eTrainApp | Dashboard";
    }
  }, [user_id]);

  const StatCard = ({ title, value, subtitle, icon, style, children }) => {
    const IconComponent = style?.icon;
    return (
      <div
        className="stat-card rounded border bg-white position-relative overflow-hidden h-100"
        style={{
          borderColor: style?.border,
          background: style?.bg,
          minHeight: '50px'
        }}
      >
        <div className="p-1 h-100 d-flex flex-column"> {/* Réduit le padding de p-2 à p-1 */}
          {/* Ligne icône + titre */}
          <div className="d-flex align-items-center mb-0"> {/* Supprime le margin-bottom */}
            {/* Icône */}
            <div className="flex-shrink-0 mr-1"> {/* Réduit le margin de me-2 à me-1 */}
              {IconComponent && <IconComponent size={14} style={{ color: style?.color }} />} {/* Réduit de 16 à 14 */}
            </div>

            {/* Titre */}
            <div className="flex-grow-1">
              <h6 className="mb-0 fw-semibold text-dark small text-truncate" title={title}>{title}</h6>
            </div>
          </div>

          {/* Contenu principal (valeur et sous-titre) */}
          <div className="flex-grow-1 d-flex flex-column justify-content-center text-center">
            {value && (
              <div>
                <h5 className="mb-0 fw-bold text-dark" style={{ fontSize: '0.95rem' }}>{value}</h5> {/* Réduit légèrement la taille */}
                {subtitle && <small className="text-muted" style={{ fontSize: '0.7rem' }}>{subtitle}</small>}
              </div>
            )}
          </div>

          {/* Enfants (contenu supplémentaire) en bas */}
          {children && (
            <div className="mt-0"> {/* Supprime le margin-top */}
              {children}
            </div>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    document.title = "eTrainApp | Dashboard";
  });

  // STATES POUR LA RÉSERVATION
  const [showReservationModal, setShowReservationModal] = useState(false);
  const [selectedBookingItem, setSelectedBookingItem] = useState(null);
  const [reservationData, setReservationData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const showAlert = (message, type = 'primary') => {
    setAlert({ message, type });
  };

  const [alertModal, setAlertModal] = useState({ message: '', type: '' });
  const showAlertModal = (message, type = 'primary') => {
    setAlertModal({ message, type });
  };

  const fermerNotif = () => {
    setAlert({ message: '', type: '' });
    setAlertModal({ message: '', type: '' });
  };

  // Récupérer les bookings depuis l'API
  const fetchBookings = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-bookings-client/${user_id}/`);

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

      const data = await response.json();

      if (data.status === 'success') {
        // Transformer les données de l'API
        const transformedBookings = data.bookings.map(booking => ({
          id: booking?.id,
          title: booking?.titre,
          reference: booking?.reference,
          type: booking?.type_booking,
          lieu: booking?.lieu,
          description: booking?.description,
          color: booking?.couleur,
          nb_participants: booking?.nb_participants,
          nb_place_total: booking?.nb_place_total,
          heure_deb: booking?.heure_deb,
          heure_fin: booking?.heure_fin,
          type_crenau: booking?.type_crenau,
          reservations: booking?.reservations || [],
          dates_booking: booking?.dates_booking || [],
          lien_teams: booking?.lien_teams || '',
          date_booking: booking?.date_booking
        }));

        setAvailableBookings(transformedBookings);

      } else {
        throw new Error(data.message || 'Erreur inconnue');
      }

    } catch (error) {
      console.error('Erreur:', error);
      showAlert(`Erreur de chargement: ${error.message}`, 'danger');
    } finally {
      setIsLoading(false);
    }
  };

  const refetchBookings = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-bookings-client/${user_id}/`);

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

      const data = await response.json();

      if (data.status === 'success') {
        const transformedBookings = data.bookings.map(booking => ({
          id: booking?.id,
          reference: booking?.reference,
          title: booking?.titre,
          type: booking?.type_booking,
          lieu: booking?.lieu,
          description: booking?.description,
          color: booking?.couleur,
          nb_participants: booking?.nb_participants,
          nb_place_total: booking?.nb_place_total,
          heure_deb: booking?.heure_deb || '09:00',
          heure_fin: booking?.heure_fin || '10:00',
          type_crenau: booking?.type_crenau || 'en_ligne',
          reservations: booking?.reservations || [],
          dates_booking: booking?.dates_booking || [],
          lien_teams: booking?.lien_teams || '',
          date_booking: booking?.date_booking
        }));

        setAvailableBookings(transformedBookings);

      } else {
        throw new Error(data.message || 'Erreur inconnue');
      }

    } catch (error) {
      console.error('Erreur:', error);
      showAlert(`Erreur de chargement: ${error.message}`, 'danger');
    } finally {
      setIsLoading(false);
    }
  };

  // Transformer les bookings en événements pour le calendrier
  const transformBookingsToEvents = useCallback(() => {
    const events = [];

    availableBookings?.forEach(booking => {
      if (booking.date_booking && booking.heure_deb && booking.heure_fin) {
        const formattedDate = moment(booking.date_booking).format('YYYY-MM-DD');

        events.push({
          id: booking.id,
          title: `${booking.heure_deb} - ${booking.type} (${booking.nb_participants} places)`,
          start: formattedDate + 'T' + booking.heure_deb,
          end: formattedDate + 'T' + booking.heure_fin,
          color: booking.color,
          extendedProps: {
            bookingTitle: booking.title,
            type_booking: booking.type,
            type_crenau: booking.type_crenau,
            nb_participants: booking.nb_participants,
            nb_place_total: booking.nb_place_total,
            bookingColor: booking.color,
            description: booking.description,
            date_booking: booking.date_booking,
            heure_deb: booking.heure_deb,
            heure_fin: booking.heure_fin,
            lieu: booking.lieu,
            reference: booking.reference
          }
        });
      }
    });

    return events;
  }, [availableBookings]);

  const [calendarEvents, setCalendarEvents] = useState([]);

  useEffect(() => {
    const events = transformBookingsToEvents();
    setCalendarEvents(events);
  }, [transformBookingsToEvents]);

  // Charger les bookings au démarrage
  useEffect(() => {
    fetchBookings();
  }, []);

  const handlePreviousMonth = () => {
    setCurrentMonth(prev => moment(prev).subtract(1, 'month'));
  };

  const handleNextMonth = () => {
    setCurrentMonth(prev => moment(prev).add(1, 'month'));
  };

  const handleToday = () => {
    setCurrentMonth(moment());
    setSelectedDate(moment());
  };

  function handleFermerReservationModal() {
    setShowReservationModal(false);
    fermerNotif();
  }

  // Fonction pour gérer la réservation
  const handleReservation = async (booking) => {

    if (!user_id) {
      // Validation des champs
      if (!reservationData.nom.trim() || !reservationData.prenom.trim() ||
        !reservationData.email.trim() || !reservationData.telephone.trim()) {
        showAlertModal('Veuillez remplir tous les champs obligatoires', 'warning');
        return;
      }

      // Validation email basique
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(reservationData.email)) {
        showAlertModal('Veuillez entrer une adresse email valide', 'warning');
        return;
      }
    }

    setSubmittingBookings(prev => ({ ...prev, [booking.id]: true }));
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/reserver-booking/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          booking_id: booking.id,
          nom: reservationData.nom,
          prenom: reservationData.prenom,
          email: reservationData.email,
          telephone: reservationData.telephone,
          user_id: user_id ? user_id : 0
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        showAlertModal(`${data.message}`, 'danger');
      }

      if (data.status === 'success') {
        showAlert('Réservation faite avec succès !', 'success');
        setShowReservationModal(false);
        setReservationData({
          nom: '',
          prenom: '',
          email: '',
          telephone: ''
        });
        setShowBookingsModal(false)
        // Recharger les données pour mettre à jour les disponibilités
        await refetchBookings();
      } else {
        throw new Error(data.message || 'Erreur lors de la réservation');
      }

    } catch (error) {
      console.error('Erreur réservation:', error);
    } finally {
      setSubmittingBookings(prev => ({ ...prev, [booking.id]: false }));
    }
  };

  // Fonction pour obtenir les bookings d'une date spécifique
  const getBookingsForDate = (date) => {
    const bookings = [];
    const dateStr = moment(date).format('YYYY-MM-DD');

    if (availableBookings && availableBookings.length > 0) {
      availableBookings.forEach(booking => {
        if (booking.date_booking === dateStr) {
          bookings.push({
            ...booking,
            bookingTitle: booking.title,
            bookingColor: booking.color
          });
        }
      });
    }

    return bookings;
  };

  const [activeTab, setActiveTab] = useState('calendrier');
  const [reservations, setReservations] = useState([]);
  const [isLoadingReservations, setIsLoadingReservations] = useState(false);

  // STATES POUR LE FILTRAGE
  const [bookingsFilter, setBookingsFilter] = useState('all');
  const [availableBookingsList, setAvailableBookingsList] = useState([]);

  const fetchReservations = async () => {
    setIsLoadingReservations(true);
    try {
      let url = `${process.env.REACT_APP_HOTE}/liste-reservations-client/${user_id}/`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des réservations');
      }

      const data = await response.json();

      if (data.status === 'success') {
        setReservations(data.reservations);

        // Extraire les bookings uniques pour le filtrage
        const uniqueBookings = [];
        const bookingsSet = new Set();

        data.reservations.forEach(reservation => {
          const bookingKey = `${reservation.date}_${reservation.heure_deb}_${reservation.heure_fin}`;
          if (!bookingsSet.has(bookingKey)) {
            bookingsSet.add(bookingKey);
            uniqueBookings.push({
              id: bookingKey,
              date: reservation.date,
              heure_deb: reservation.heure_deb,
              heure_fin: reservation.heure_fin,
              display: `${moment(reservation.date).format('DD/MM/YYYY')} - ${reservation.heure_deb} à ${reservation.heure_fin}`
            });
          }
        });

        setAvailableBookingsList(uniqueBookings);
        setBookingsFilter('all');
      } else {
        throw new Error(data.message || 'Erreur inconnue');
      }

    } catch (error) {
      console.error('Erreur:', error);
      showAlert(`Erreur de chargement des réservations: ${error.message}`, 'danger');
    } finally {
      setIsLoadingReservations(false);
    }
  };

  // Fonction pour vérifier si l'annulation est encore possible
  const canCancelReservation = (reservation) => {
    if (!reservation?.date || !reservation?.heure_deb) return false;

    const reservationDateTime = moment(`${reservation.date} ${reservation.heure_deb}`, 'YYYY-MM-DD HH:mm');
    const now = moment();
    const timeDifference = reservationDateTime.diff(now, 'hours', true);

    return timeDifference > 24;
  };


  const handleCloseBookingModal = () => {
    setShowBookingsModal(false)
    fermerNotif()
  };

  const [isChargement, setIsChargement] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [annulationMotif, setAnnulationMotif] = useState('');

  // Fonction pour ouvrir le modal d'annulation
  const handleOpenCancelModal = (reservation) => {
    setSelectedReservation(reservation);
    setShowCancelModal(true);
  };

  // Fonction pour confirmer l'annulation
  const handleCancelAction = async () => {
    if (!selectedReservation || !annulationMotif.trim()) return;

    try {
      setIsChargement(true);

      const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-statut-reservation/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          reservation_id: selectedReservation.id,
          statut: '3',
          user_id: user_id,
          motif_annulation: annulationMotif
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erreur lors de l\'annulation');
      }

      if (data.status === 'success') {
        setReservations(prevReservations =>
          prevReservations.map(reservation =>
            reservation.id === selectedReservation.id
              ? {
                ...reservation,
                statut: '3',
                motif_annulation: annulationMotif
              }
              : reservation
          )
        );

        showAlert(data.message, 'success');
        setShowCancelModal(false);
        setAnnulationMotif('');
        await refetchBookings();
      } else {
        throw new Error(data.message || 'Erreur lors de l\'annulation');
      }

    } catch (error) {
      console.error('Erreur lors de l\'annulation:', error);
      showAlert(`Erreur: ${error.message}`, 'danger');
    } finally {
      setIsChargement(false);
    }
  };

  const [showBookingsModal, setShowBookingsModal] = useState(false);
  const [selectedDayBookings, setSelectedDayBookings] = useState([]);

  // const handleDateClick = (arg) => {
  //   const clickedDate = moment(arg.date);
  //   const today = moment().startOf('day');

  //   setAlert({ message: '', type: '' });
  //   setAlertModal({ message: '', type: '' });

  //   // Vérifier si la date est dans le passé (comme dans GestionRendezVousCoach)
  //   if (clickedDate.isBefore(today)) {
  //     showAlertModal('Impossible de sélectionner une date déjà passée', 'warning');
  //     return;
  //   }

  //   setSelectedDate(clickedDate);
  //   const bookings = getBookingsForDate(clickedDate);
  //   if (bookings.length > 0) {
  //     setSelectedDayBookings(bookings);
  //     setShowBookingsModal(true);
  //   }
  // };


  const handleDateClick = (arg) => {
    if (userHasAccess("Administration")) {
      handleCoachDateClick(arg);
    } else {
      // Garder l'ancienne logique pour les clients
      const clickedDate = moment(arg.date);
      const today = moment().startOf('day');

      setAlert({ message: '', type: '' });
      setAlertModal({ message: '', type: '' });

      if (clickedDate.isBefore(today)) {
        showAlertModal('Impossible de sélectionner une date déjà passée', 'danger');
        return;
      }

      setSelectedDate(clickedDate);
      const bookings = getBookingsForDate(clickedDate);
      if (bookings.length > 0) {
        setSelectedDayBookings(bookings);
        setShowBookingsModal(true);
      }
    }
  };

  // Fonction pour déterminer si un événement est passé (identique à celle dans CustomCalendar)
  const isEventPast = (event) => {
    const dateBooking = event.extendedProps?.date_booking;
    const heureDeb = event.extendedProps?.heure_deb;

    if (!dateBooking || !heureDeb) return false;

    const eventDateTime = new Date(dateBooking + 'T' + heureDeb);
    const now = new Date();
    return now > eventDateTime;
  };

  const handleEventClick = (clickInfo) => {
    const booking = availableBookings.find(b => b.id === clickInfo.event.id);

    // Vérifier si l'événement est passé
    if (booking) {
      const isPast = isEventPast({
        extendedProps: {
          date_booking: booking.date_booking,
          heure_deb: booking.heure_deb
        }
      });

      if (isPast) {
        showAlert('Cet événement est déjà passé et ne peut pas être réservé', 'warning');
        return;
      }

      setSelectedBookingItem(booking);
      setShowReservationModal(true);
    }
  };

  // FONCTION pour sélectionner un booking et ouvrir le modal de réservation
  const handleBookingSelect = (booking) => {
    // Vérifier si le booking est passé
    const isPast = isEventPast({
      extendedProps: {
        date_booking: booking.date_booking,
        heure_deb: booking.heure_deb
      }
    });

    if (isPast) {
      showAlert('Cet événement est déjà passé et ne peut pas être réservé', 'warning');
      return;
    }

    setSelectedBookingItem(booking);
    setShowBookingsModal(false);
    setShowReservationModal(true);
  };


  const renderCalendar = () => {
    return (
      <div className="calendar-container">
        <CustomCalendar
          events={calendarEvents}
          onDateClick={handleDateClick}
          onEventClick={handleEventClick}
          onBookingClick={handleBookingClick}
          onBookingCoachClick={handleCoachDateClick}
          initialView="dayGridMonth"
          height="600px"
        />
      </div>
    );
  };


  const handleBookingClick = (eventInfo) => {
    if (userHasAccess('Administration')) {
      // Récupérer la date de l'événement
      const eventDate = moment(eventInfo.event.start);

      // Vérifier si la date est dans le passé
      const today = moment().startOf('day');
      // if (eventDate.isBefore(today)) {
      //   showAlert('Impossible de sélectionner une date déjà passée', 'warning');
      //   return;
      // }

      // Récupérer les bookings pour cette date
      const bookings = getBookingsForDate(eventDate);
      if (bookings.length > 0) {
        setSelectedDate(eventDate);
        setSelectedDayBookings(bookings);
        setShowBookingsModal(true);
      } else {
        showAlert('Aucun booking disponible pour cette date', 'info');
      }
    } else {
      // Récupérer la date de l'événement
      const eventDate = moment(eventInfo.event.start);

      // Vérifier si la date est dans le passé
      const today = moment().startOf('day');
      if (eventDate.isBefore(today)) {
        showAlert('Impossible de sélectionner une date déjà passée', 'warning');
        return;
      }

      // Récupérer les bookings pour cette date
      const bookings = getBookingsForDate(eventDate);
      if (bookings.length > 0) {
        setSelectedDate(eventDate);
        setSelectedDayBookings(bookings);
        setShowBookingsModal(true);
      } else {
        showAlert('Aucun booking disponible pour cette date', 'info');
      }
    }
  };

  // États pour la pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: 'date_creation', direction: 'descending' });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const renderReservations = () => {
    if (isLoadingReservations) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
          <div className="spiner-example">
            <div className="sk-spinner sk-spinner-wave">
              <div className="sk-rect1 mr-1"></div>
              <div className="sk-rect2 mr-1"></div>
              <div className="sk-rect3 mr-1"></div>
              <div className="sk-rect4 mr-1"></div>
              <div className="sk-rect5"></div>
            </div>
          </div>
        </div>
      );
    }

    // Fonction de tri
    const handleSort = (key) => {
      let direction = 'ascending';
      if (sortConfig.key === key && sortConfig.direction === 'ascending') {
        direction = 'descending';
      }
      setSortConfig({ key, direction });
      setCurrentPage(1); // Retour à la première page après tri
    };

    // Appliquer le tri aux réservations filtrées
    const sortedReservations = [...reservations.filter(reservation =>
      bookingsFilter === 'all' ||
      `${reservation.date}_${reservation.heure_deb}_${reservation.heure_fin}` === bookingsFilter
    )].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });

    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentReservations = sortedReservations.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(sortedReservations.length / itemsPerPage);

    // Fonction pour changer de page
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };

    // Fonction pour changer le nombre d'éléments par page
    const handleItemsPerPageChange = (e) => {
      setItemsPerPage(parseInt(e.target.value));
      setCurrentPage(1);
    };

    return (
      <div className="reservations-container">
        {/* En-tête avec filtre et compteur */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="mb-1">Mes Réservations</h4>
            <p className="text-muted mb-0">
              {sortedReservations.length} réservation{sortedReservations.length > 1 ? 's' : ''}
            </p>
          </div>

          <div className="d-flex align-items-center gap-3">
            {availableBookingsList.length > 0 && (
              <Form.Select
                value={bookingsFilter}
                onChange={(e) => {
                  setBookingsFilter(e.target.value);
                  setCurrentPage(1);
                }}
                style={{ width: 'auto', minWidth: '250px' }}
                size="sm"
              >
                <option value="all">Tous les bookings</option>
                {availableBookingsList.map(booking => (
                  <option key={booking.id} value={booking.id}>
                    {booking.display}
                  </option>
                ))}
              </Form.Select>
            )}

            <div className="d-flex align-items-center gap-2">
              {bookingsFilter !== 'all' && (
                <Badge
                  bg="secondary"
                  className="fs-6 cursor-pointer text-white"
                  onClick={() => {
                    setBookingsFilter('all');
                    setCurrentPage(1);
                  }}
                >
                  <FaTimes className="mr-1" />
                  Effacer le filtre
                </Badge>
              )}
            </div>
          </div>
        </div>

        {sortedReservations.length > 0 ? (
          <div className="ibox">
            <div className="ibox-content">
              {/* Contrôles de pagination en haut */}
              <div className="d-flex justify-content-start align-items-center mb-3">
                <div className="d-flex align-items-center gap-2">
                  <Form.Select
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                    style={{ width: 'auto' }}
                    size="sm"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                  </Form.Select>
                </div>
              </div>

              <div className="table-responsive-md"> {/* Seulement pour medium et plus */}
                <table className="footable table table-stripped footable-loaded">
                  <thead className="d-md-table-header-group" style={{ fontSize: '11px' }}> {/* Cache le header sur mobile */}
                    <tr>
                      <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date_creation')}>
                        Date de réservation
                        {sortConfig.key === 'date_creation' && (
                          sortConfig.direction === 'ascending' ?
                            <FaSortAmountUp className="ms-1" /> :
                            <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nom')}>
                        Client
                        {sortConfig.key === 'nom' && (
                          sortConfig.direction === 'ascending' ?
                            <FaSortAmountUp className="ms-1" /> :
                            <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th className='text-secondary text-wrap d-none d-lg-table-cell cursor-pointer' onClick={() => handleSort('email')}>
                        Contact
                        {sortConfig.key === 'email' && (
                          sortConfig.direction === 'ascending' ?
                            <FaSortAmountUp className="ms-1" /> :
                            <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date')}>
                        Date de booking
                        {sortConfig.key === 'date' && (
                          sortConfig.direction === 'ascending' ?
                            <FaSortAmountUp className="ms-1" /> :
                            <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('type_crenau')}>
                        Type
                        {sortConfig.key === 'type_crenau' && (
                          sortConfig.direction === 'ascending' ?
                            <FaSortAmountUp className="ms-1" /> :
                            <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('statut')}>
                        Statut
                        {sortConfig.key === 'statut' && (
                          sortConfig.direction === 'ascending' ?
                            <FaSortAmountUp className="ms-1" /> :
                            <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th className='text-secondary text-wrap text-end d-none'>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentReservations.map((reservation) => (
                      <tr key={reservation.id} className="bg-white">
                        {/* Version desktop */}
                        <td className="d-none d-md-table-cell">
                          <div className="fw-bold">
                            Réservé le {moment(reservation.date_creation).format('DD/MM/YYYY à HH:mm')}
                          </div>
                        </td>
                        <td className="d-none d-md-table-cell">
                          <div className="fw-bold">
                            {reservation.prenom} {reservation.nom}
                          </div>
                        </td>
                        <td className="d-none d-lg-table-cell">
                          <div className="d-flex flex-column">
                            <small>
                              <FaUser size={10} className="mr-1" />
                              {reservation.email}
                            </small>
                            <small className="mt-1">
                              <FaPhone size={10} className="mr-1" />
                              {reservation.telephone || 'Non renseigné'}
                            </small>
                          </div>
                        </td>
                        <td className="d-none d-md-table-cell">
                          <div className="fw-bold text-dark">
                            {moment(reservation.date).format('DD/MM/YYYY')}
                          </div>
                          <div className="text-muted small">
                            {reservation.heure_deb} - {reservation.heure_fin}
                          </div>
                        </td>
                        <td className="d-none d-md-table-cell">
                          <span>
                            {reservation.type_crenau === 'en_ligne' ? 'Virtuel' : 'Présentiel'}
                          </span>
                          {reservation.statut === '2' && reservation.type_crenau === 'en_ligne' && (
                            <a
                              href={reservation.lien_teams}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-decoration-none ms-1"
                              title="Rejoindre la visioconférence Teams"
                            >
                              <FaVideo className="text-primary ml-2" size={14} />
                            </a>
                          )}
                        </td>
                        <td className="d-none d-md-table-cell">
                          <Badge
                            bg={
                              reservation.statut === '1' ? 'warning' :
                                reservation.statut === '2' ? 'success' :
                                  'danger'
                            }
                          >
                            {reservation.statut === '1' && 'En attente'}
                            {reservation.statut === '2' && 'Confirmée'}
                            {reservation.statut === '3' && 'Annulée'}
                          </Badge>
                        </td>
                        <td className='text-end d-none d-md-table-cell'>
                          {(reservation.statut === '1' || reservation.statut === '2') && (
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="outline-"
                                size="sm"
                                id={`dropdown-reservation-${reservation.id}`}
                                className="d-flex align-items-center"
                              >
                                <FaEllipsisV />
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {(reservation.statut === '1' || reservation.statut === '2') && (
                                  <Dropdown.Item
                                    onClick={() => handleOpenCancelModal(reservation)}
                                    className="d-flex align-items-center text-danger"
                                  >
                                    <FaTimes className="mr-2" />
                                    Annuler
                                  </Dropdown.Item>
                                )}
                                {reservation.statut === '2' && reservation.type_crenau === 'en_ligne' && reservation.lien_teams && (
                                  <Dropdown.Item
                                    href={reservation.lien_teams}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-flex align-items-center text-primary"
                                  >
                                    <FaVideo className="mr-2" />
                                    Rejoindre Teams
                                  </Dropdown.Item>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        </td>

                        {/* Version mobile */}
                        <td className="d-md-none">
                          <div className="reservation-card-mobile p-3 border rounded mb-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div>
                                <h6 className="fw-bold mb-1">{reservation.prenom} {reservation.nom}</h6>
                                <small className="text-muted">
                                  Réservé le {moment(reservation.date_creation).format('DD/MM/YYYY à HH:mm')}
                                </small>
                              </div>
                              <Badge
                                bg={
                                  reservation.statut === '1' ? 'warning' :
                                    reservation.statut === '2' ? 'success' :
                                      'danger'
                                }
                              >
                                {reservation.statut === '1' && 'En attente'}
                                {reservation.statut === '2' && 'Confirmée'}
                                {reservation.statut === '3' && 'Annulée'}
                              </Badge>
                            </div>

                            <div className="reservation-details">
                              <div className="detail-item mb-2">
                                <strong>Booking:</strong> {moment(reservation.date).format('DD/MM/YYYY')}
                                de {reservation.heure_deb} à {reservation.heure_fin}
                              </div>
                              <div className="detail-item mb-2">
                                <strong>Type:</strong> {reservation.type_crenau === 'en_ligne' ? 'Virtuel' : 'Présentiel'}
                                {reservation.statut === '2' && reservation.type_crenau === 'en_ligne' && reservation.lien_teams && (
                                  <a
                                    href={reservation.lien_teams}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none ms-2"
                                    title="Rejoindre Teams"
                                  >
                                    <FaVideo className="text-primary" size={14} />
                                  </a>
                                )}
                              </div>
                              <div className="detail-item mb-2">
                                <strong>Contact:</strong> {reservation.email}
                              </div>
                              {reservation.telephone && (
                                <div className="detail-item mb-2">
                                  <strong>Tél:</strong> {reservation.telephone}
                                </div>
                              )}
                            </div>

                            <div className="reservation-actions mt-3 pt-2 border-top">
                              <div className="d-flex gap-2">
                                {(reservation.statut === '1' || reservation.statut === '2') && (
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => handleOpenCancelModal(reservation)}
                                    className="flex-fill"
                                  >
                                    <FaTimes className="mr-1" />
                                    Annuler
                                  </Button>
                                )}
                                {reservation.statut === '2' && reservation.type_crenau === 'en_ligne' && reservation.lien_teams && (
                                  <Button
                                    variant="primary"
                                    size="sm"
                                    href={reservation.lien_teams}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex-fill"
                                  >
                                    <FaVideo className="me-1" />
                                    Teams
                                  </Button>
                                )}
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination en bas */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="dataTables_info" role="status" aria-live="polite">
                  Affichage de {indexOfFirstItem + 1} à {Math.min(indexOfLastItem, sortedReservations.length)} sur {sortedReservations.length} réservation{sortedReservations.length !== 1 ? 's' : ''}
                </div>

                {totalPages > 1 && (
                  <div>
                    <button
                      onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                      className="btn btn-light mx-1"
                      disabled={currentPage === 1}
                    >
                      <FaArrowLeft />
                    </button>

                    {(() => {
                      const pagesToShow = 5; // Nombre total de pages à afficher
                      let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                      let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                      // Ajuster le startPage si la fin dépasse le total des pages
                      if (endPage - startPage < pagesToShow - 1) {
                        startPage = Math.max(1, endPage - pagesToShow + 1);
                      }

                      const pageButtons = [];

                      // Ajout des boutons de pages
                      for (let i = startPage; i <= endPage; i++) {
                        pageButtons.push(
                          <button
                            key={i}
                            onClick={() => setCurrentPage(i)}
                            className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                          >
                            {i}
                          </button>
                        );
                      }

                      return pageButtons;
                    })()}

                    <button
                      onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                      className="btn btn-light mx-1"
                      disabled={currentPage === totalPages}
                    >
                      <FaArrowRight />
                    </button>

                    {/* Bouton pour aller à la dernière page */}
                    <button
                      onClick={() => setCurrentPage(totalPages)}
                      className="btn btn-light mx-1"
                      disabled={currentPage === totalPages}
                    >
                      {totalPages}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-5">
            {/* <FaUser size={40} className="text-muted mb-3" /> */}
            <h5 className="text-muted">Aucune réservation</h5>
            <Button
              variant="primary"
              onClick={() => {
                setBookingsFilter('all');
                setActiveTab('calendrier');
              }}
            >
              Réserver un booking
            </Button>
          </div>
        )}
      </div>
    );
  };





  const [showCoachBookingModal, setShowCoachBookingModal] = useState(false);
  const [selectedDateBookings, setSelectedDateBookings] = useState([]);
  const [selectedDateReservations, setSelectedDateReservations] = useState([]);

  // Fonction pour gérer le clic sur une date (version coach)
  const handleCoachDateClick = (arg) => {
    const clickedDate = moment(arg.date);
    const today = moment().startOf('day');

    setAlert({ message: '', type: '' });
    setAlertModal({ message: '', type: '' });

    // Vérifier si la date est dans le passé
    if (clickedDate.isBefore(today)) {
      showAlertModal('Impossible de sélectionner une date déjà passée', 'info');
      return;
    }

    setSelectedDate(clickedDate);

    // Récupérer les bookings de cette date
    const bookings = getBookingsForDate(clickedDate);

    if (bookings.length > 0) {
      setSelectedDateBookings(bookings);

      // Récupérer les réservations pour ces bookings
      fetchReservationsForDate(clickedDate, bookings);
    } else {
      showAlertModal('Aucun booking disponible pour cette date', 'info');
    }
  };

  // Fonction pour récupérer les réservations d'une date spécifique
  const fetchReservationsForDate = async (date, bookings) => {
    try {
      // Si c'est un coach, récupérer toutes les réservations et filtrer par date

      const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-reservations/`);

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des réservations');
      }

      const data = await response.json();

      if (data.status === 'success') {
        const dateStr = moment(date).format('YYYY-MM-DD');

        // Filtrer les réservations pour la date sélectionnée
        const reservationsForDate = data.reservations.filter(reservation =>
          reservation.date === dateStr
        );

        setSelectedDateReservations(reservationsForDate);
        setShowCoachBookingModal(true);
      }
    } catch (error) {
      console.error('Erreur:', error);
      showAlertModal(`Erreur de chargement des réservations: ${error.message}`, 'danger');
    }
  };

  // Modal spécial pour le coach
  const renderCoachBookingModal = () => {
    const dateStr = moment(selectedDate).format('DD/MM/YYYY');

    return (
      <Modal show={showCoachBookingModal} onHide={() => setShowCoachBookingModal(false)} size="xl">
        <Modal.Header>
          <Modal.Title>
            {/* <FaCalendarAlt className="mr-2" /> */}
            Réservations Clients du {dateStr}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0">
          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h4 className="mb-1">Réservations du {dateStr}</h4>
                <p className="text-muted mb-0">
                  {selectedDateReservations.length} réservation{selectedDateReservations.length > 1 ? 's' : ''}
                </p>
              </div>
            </div>

            {selectedDateReservations.length > 0 ? (
              <div className="ibox">
                <div className="ibox-content">
                  <div className="table-responsive">
                    <table className="footable table table-stripped footable-loaded">
                      <thead>
                        <tr>
                          <th className='text-secondary text-wrap'>Client</th>
                          <th className='text-secondary text-wrap'>Contact</th>
                          <th className='text-secondary text-wrap'>Booking</th>
                          <th className='text-secondary text-wrap'>Horaire</th>
                          <th className='text-secondary text-wrap'>Type</th>
                          <th className='text-secondary text-wrap'>Statut</th>
                          <th className='text-secondary text-wrap'>Date Réservation</th>
                          {/* <th className='text-secondary text-wrap text-end'>Actions</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {selectedDateReservations.map((reservation) => (
                          <tr key={reservation.id} className="bg-white">
                            <td>
                              <div className="fw-bold">
                                {reservation.prenom} {reservation.nom}
                              </div>
                            </td>
                            <td>
                              <div className="small">
                                <div>
                                  <FaUser size={12} className="mr-1 text-muted" />
                                  {reservation.email}
                                </div>
                                {reservation.telephone && (
                                  <div className="mt-1">
                                    <FaPhone size={12} className="mr-1 text-muted" />
                                    {reservation.telephone}
                                  </div>
                                )}
                              </div>
                            </td>
                            <td>
                              <div className="fw-bold text-dark">
                                {reservation.booking_title}
                              </div>
                              <div className="text-muted small">
                                {reservation.type_booking}
                              </div>
                            </td>
                            <td>
                              <div className="fw-bold text-dark">
                                {reservation.heure_deb} - {reservation.heure_fin}
                              </div>
                            </td>
                            <td>
                              {reservation.type_crenau === 'en_ligne' ? 'Virtuel' : 'Présentiel'}
                            </td>
                            <td>
                              {reservation.statut === '1' && 'En attente'}
                              {reservation.statut === '2' && 'Confirmée'}
                              {reservation.statut === '3' && 'Annulée'}
                              {reservation.statut === '3' && reservation.motif_annulation && (
                                <div className="mt-1">
                                  <small className="text-muted">
                                    {reservation.motif_annulation}
                                  </small>
                                </div>
                              )}
                            </td>
                            <td>
                              <div className="small text-muted">
                                {moment(reservation.date_creation).format('DD/MM/YYYY HH:mm')}
                              </div>
                            </td>
                            {/* <td className='text-end'>
                            {reservation.statut === '2' && reservation.type_crenau === 'en_ligne' && reservation.lien_teams && (
                              <Button
                                variant="outline-primary"
                                size="sm"
                                href={reservation.lien_teams}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-flex align-items-center"
                                title="Rejoindre la visioconférence Teams"
                              >
                                <FaVideo className="mr-1" />
                                Teams
                              </Button>
                            )}
                          </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Résumé en bas */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="dataTables_info" role="status" aria-live="polite">
                      {selectedDateReservations.length === 0
                        ? "Aucune réservation à afficher"
                        : `Affichage de ${selectedDateReservations.length} réservation${selectedDateReservations.length !== 1 ? 's' : ''}`}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center py-5">
                {/* <FaUser size={40} className="text-muted mb-3" /> */}
                <h5 className="text-muted">Aucune réservation</h5>
                <p className="text-muted">
                  Aucun client n'a réservé de booking pour le {dateStr}
                </p>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCoachBookingModal(false)}>
            Fermer
          </Button>
          {/* <Button 
          variant="primary"
          onClick={() => {
            setShowCoachBookingModal(false);
            // Optionnel: naviguer vers une vue complète des réservations
            // setActiveTab('coach-reservations');
            // fetchAllReservations();
          }}
        >
          <FaList className="mr-1" />
          Voir toutes les réservations
        </Button> */}
        </Modal.Footer>
      </Modal>
    );
  };



  if (isLoading) {
    return (
      <div id="wrapper">
        <Sidebar user_id={user_id} />
        <div id="page-wrapper" className="gray-bg">
          <Navbar />
          <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
            <div className="spiner-example">
              <div className="sk-spinner sk-spinner-wave">
                <div className="sk-rect1 mr-1"></div>
                <div className="sk-rect2 mr-1"></div>
                <div className="sk-rect3 mr-1"></div>
                <div className="sk-rect4 mr-1"></div>
                <div className="sk-rect5"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="wrapper">
      <Sidebar user_id={localStorage.getItem('user_id') || '0'} />
      <div id="page-wrapper" className="gray-bg">

        {user_id && <Navbar />}

        <div className="prise-rendez-vous-client">
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className="d-flex align-items-center">
                <FaHome size={25} className="mr-2" />
                Dashboard
              </h2>
              {/* <small className="text-muted">Aperçu de votre progression et performance</small> */}
            </div>
          </div>


          {alert.message && (
            <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2 mt-2`}>
              <div dangerouslySetInnerHTML={{ __html: alert.message }} />
              <span
                onClick={fermerNotif}
                style={{
                  position: 'absolute',
                  top: '0px',
                  right: '10px',
                  cursor: 'pointer'
                }}
              >
                <i className='fa fa-close'></i>
              </span>
            </div>
          )}

          <div className="wrapper wrapper-content animated fadeInRight">
            <Row>
              <Col lg={4} className="h-100">
                <section id="linkedin-feed" className="linkedin-feed-section">
                  <div className="container">

                    {/* Carousel LinkedIn amélioré */}
                    <div className="row justify-content-center">
                      <div className="col-lg-12">
                        {isMobile ? (
                          <div className="linkedin-carousel-container position-relative">
                            {/* Flèches de navigation */}
                            <button
                              className="carousel-arrow carousel-arrow-left"
                              onClick={() => {
                                const track = document.querySelector('.linkedin-carousel-track');
                                track.scrollBy({ left: -window.innerWidth * 0.8, behavior: 'smooth' });
                              }}
                            >
                              <FaChevronLeft size={16} />
                            </button>

                            <button
                              className="carousel-arrow carousel-arrow-right"
                              onClick={() => {
                                const track = document.querySelector('.linkedin-carousel-track');
                                track.scrollBy({ left: window.innerWidth * 0.8, behavior: 'smooth' });
                              }}
                            >
                              <FaChevronRight size={16} />
                            </button>

                            {/* Piste du carousel */}
                            <div
                              className="linkedin-carousel-track"
                              style={{
                                display: 'flex',
                                gap: '20px',
                                padding: '15px 10px',
                                overflowX: 'auto',
                                scrollBehavior: 'smooth',
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#c1c1c1 transparent',
                                cursor: 'grab'
                              }}
                              onMouseDown={(e) => {
                                const track = e.currentTarget;
                                const startX = e.pageX - track.offsetLeft;
                                const scrollLeft = track.scrollLeft;
                                track.style.cursor = 'grabbing';
                                track.style.scrollBehavior = 'auto';

                                const mouseMoveHandler = (e) => {
                                  const x = e.pageX - track.offsetLeft;
                                  const walk = (x - startX) * 2;
                                  track.scrollLeft = scrollLeft - walk;
                                };

                                const mouseUpHandler = () => {
                                  track.style.cursor = 'grab';
                                  track.style.scrollBehavior = 'smooth';
                                  document.removeEventListener('mousemove', mouseMoveHandler);
                                  document.removeEventListener('mouseup', mouseUpHandler);
                                };

                                document.addEventListener('mousemove', mouseMoveHandler);
                                document.addEventListener('mouseup', mouseUpHandler);
                              }}
                            >
                              {/* Post 1 */}
                              <div
                                className="linkedin-carousel-item"
                                style={{
                                  flex: '0 0 85%',
                                  minWidth: '85%',
                                  borderRadius: '12px',
                                  overflow: 'hidden',
                                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                  transition: 'transform 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                              >
                                <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7394304853906231296?collapsed=1" height="640" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
                              </div>

                              {/* Post 2 */}
                              <div
                                className="linkedin-carousel-item"
                                style={{
                                  flex: '0 0 85%',
                                  minWidth: '85%',
                                  borderRadius: '12px',
                                  overflow: 'hidden',
                                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                  transition: 'transform 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                              >

                                <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7393561759103520770?collapsed=1" height="645" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
                              </div>

                              {/* Post 3 */}
                              <div
                                className="linkedin-carousel-item"
                                style={{
                                  flex: '0 0 85%',
                                  minWidth: '85%',
                                  borderRadius: '12px',
                                  overflow: 'hidden',
                                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                  transition: 'transform 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                              >
                                <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7393561759103520770?collapsed=1" height="645" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
                              </div>
                            </div>

                            {/* Indicateurs de défilement */}
                            <div className="carousel-indicators d-flex justify-content-center mt-3">
                              {[0, 1, 2].map((index) => (
                                <button
                                  key={index}
                                  className="carousel-indicator mx-1"
                                  onClick={() => {
                                    const track = document.querySelector('.linkedin-carousel-track');
                                    track.scrollTo({
                                      left: window.innerWidth * 0.85 * index,
                                      behavior: 'smooth'
                                    });
                                  }}
                                  style={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    border: 'none',
                                    backgroundColor: '#ccc',
                                    transition: 'background-color 0.3s ease',
                                    cursor: 'pointer'
                                  }}
                                ></button>
                              ))}
                            </div>
                          </div>
                        ) : (
                          // Version desktop - affichage normal avec scroll vertical
                          <div
                            className="desktop-linkedin-feed"
                            style={{
                              maxHeight: '800px',
                              overflowY: 'auto',
                              paddingRight: '10px'
                            }}
                          >
                            <div className="d-flex flex-column gap-4">
                              <div
                                className="linkedin-post"
                                style={{
                                  borderRadius: '12px',
                                  overflow: 'hidden',
                                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                  transition: 'transform 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                              >
                                <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7394304853906231296?collapsed=1" height="640" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
                              </div>

                              <div
                                className="linkedin-post"
                                style={{
                                  borderRadius: '12px',
                                  overflow: 'hidden',
                                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                  transition: 'transform 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                              >
                                <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7393561759103520770?collapsed=1" height="645" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
                              </div>

                              <div
                                className="linkedin-post"
                                style={{
                                  borderRadius: '12px',
                                  overflow: 'hidden',
                                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                  transition: 'transform 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                              >
                                <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7393561759103520770?collapsed=1" height="645" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Bouton de suivi */}
                        <div className="text-center mt-4">
                          <a
                            href="https://www.linkedin.com/company/inovact"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary px-4 py-2"
                            style={{
                              backgroundColor: '#0a66c2',
                              borderColor: '#0a66c2',
                              borderRadius: '25px',
                              fontWeight: '500',
                              fontSize: '0.9rem',
                              transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = '#004182';
                              e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = '#0a66c2';
                              e.target.style.transform = 'translateY(0)';
                            }}
                          >
                            Nous suivre <FaLinkedinIn className="ml-2" size={16} />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                </section>
              </Col>
              {/* Section unique - Calendrier et Réservations */}
              <Col lg={8}>
                <Card className="h-100 border-0 shadow-lg">
                  <Card.Header className="bg-white border-0">
                    {/* Onglets */}
                    <div className="d-flex border-bottom">
                      <button
                        className={`btn btn-tab d-flex justify-content-center align-items-center p-2 ${activeTab === 'calendrier' ? 'active' : ''}`}
                        onClick={() => setActiveTab('calendrier')}
                      >
                        <FaCalendarAlt className="mr-1" />
                        Calendrier
                      </button>
                      {user_id &&
                        <button
                          className={`btn btn-tab d-flex justify-content-center align-items-center p-2 ${activeTab === 'reservations' ? 'active' : ''}`}
                          onClick={() => {
                            setActiveTab('reservations');
                            fetchReservations();
                          }}
                        >
                          <FaStar className="mr-1" />
                          Mes Réservations
                        </button>
                      }
                    </div>

                    {/* Contenu de l'en-tête conditionnel */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      {activeTab === 'calendrier' && (
                        <>
                          <div>
                            <p className="text-muted mb-0 mt-1">
                              Cliquez sur une date pour voir les bookings disponibles
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                  </Card.Header>

                  <Card.Body className="pl-4 pr-4 pt-0">

                    {activeTab === 'calendrier' ? (
                      renderCalendar()
                    ) : (
                      renderReservations()
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </div>

        {/* Modal pour afficher les bookings d'un jour */}
        <Modal show={showBookingsModal} onHide={handleCloseBookingModal}>
          <Modal.Header>
            <Modal.Title>
              Booking(s) disponible(s)
            </Modal.Title>
          </Modal.Header>

          {alertModal.message && (
            <div className={`m-3 alert alert-${alertModal.type}`}>
              {alertModal.message}
            </div>
          )}
          <Modal.Body className="p-4">
            {selectedDayBookings.length > 0 ? (
              <div className="bookings-list">
                {selectedDayBookings.map((booking, index) => (
                  <Card key={index} className="mb-3 border-0">
                    <Card.Body className="p-3">
                      <div className="d-flex align-items-start">
                        {/* <div
                          className="color-indicator flex-shrink-0 mr-3"
                          style={{
                            width: '4px',
                            height: '40px',
                            backgroundColor: booking.bookingColor,
                            borderRadius: '2px'
                          }}
                        /> */}
                        <div className="flex-grow-1">
                          <div className="d-flex justify-content-between align-items-start mb-1">
                            <h4 className="mb-0 fw-bold" style={{ color: booking.bookingColor }}>
                              {booking.bookingTitle}
                            </h4>
                            <Badge
                              bg={booking.type_crenau === 'en_ligne' ? 'success' : 'warning'}
                              className="fs-8"
                            >
                              {booking.type_crenau === 'en_ligne' ? 'Virtuel' : 'Présentiel'}
                            </Badge>
                          </div>
                          {/* <small>
                            {moment(booking.date_booking).format('DD MMMM YYYY')} de {booking.heure_deb} à {booking.heure_fin}
                          </small> */}

                          {/* Afficher toutes les dates de dates_booking */}
                          {booking.dates_booking && booking.dates_booking.length > 0 && (
                            <div className="mb-2">
                              <small className="text-muted">
                                {booking.dates_booking.map((dateItem, dateIndex) => (
                                  <span key={dateIndex}>
                                    {moment(dateItem.date).format('DD MMM YYYY')}
                                    {dateIndex < booking.dates_booking.length - 1 ? ', ' : ''}
                                  </span>
                                ))}
                              </small>
                            </div>
                          )}

                          {/* Afficher le lieu si présentiel */}
                          {booking.type_crenau === 'presentiel' && booking.lieu && (
                            <div className="mt-1 small text-muted">
                              <FaMapMarkerAlt size={10} className="mr-1" />
                              {booking.lieu.length > 30 ?
                                `${booking.lieu.substring(0, 30)}...` : booking.lieu}
                            </div>
                          )}

                          <div className="d-flex justify-content-between text-muted">
                            <div className="d-flex align-items-center text-muted">
                              <FaUser size={12} className="me-1 mr-2" />
                              {booking.nb_participants > 0 ? (
                                <small>{booking.nb_participants} places disponibles</small>
                              ) : (
                                <i>Aucune place disponible</i>
                              )}
                            </div>

                            {/* BOUTON RÉSERVER */}
                            {booking.nb_participants > 0 && (() => {
                              // Vérifier si l'utilisateur a déjà une réservation active pour CETTE RÉFÉRENCE
                              const userHasActiveReservationForReference = availableBookings.some(otherBooking =>
                                otherBooking.reference === booking.reference &&
                                otherBooking.reservations &&
                                otherBooking.reservations.some(reservation =>
                                  reservation.user_id === user_id &&
                                  (reservation.statut === '1' || reservation.statut === '2')
                                )
                              );

                              // Vérifier si ce booking spécifique est disponible
                              const isThisBookingAvailable = !booking.reservations ||
                                booking.reservations.length === 0 ||
                                booking.reservations.every(r => r.statut === "3");

                              // L'utilisateur peut réserver seulement s'il n'a PAS de réservation active pour cette référence ET si ce booking est disponible
                              if (!userHasActiveReservationForReference && isThisBookingAvailable) {
                                return submittingBookings[booking.id] ? (
                                  <Button variant="success" disabled>
                                    <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                                    Réservation en cours...
                                  </Button>
                                ) : (
                                  <Button
                                    className="d-flex justify-content-center align-items-center"
                                    variant="success"
                                    size="sm"
                                    onClick={() => handleReservation(booking)}
                                  >
                                    <FaCalendarAlt className="mr-1" />
                                    Réserver ce booking
                                  </Button>
                                );
                              } else {
                                return (
                                  <div>
                                    <i className="text-success">Déjà réservé</i>
                                  </div>
                                );
                              }
                            })()}

                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            ) : (
              <div className="text-center py-4">
                <FaCalendarAlt size={40} className="text-muted mb-3" />
                <p className="text-muted">Aucun booking disponible pour cette date</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseBookingModal}>
              Fermer
            </Button>
            {userHasAccess('Administration') &&
              <Button
                className="btn btn-success ml-2"
                onClick={() => {
                  handleCloseBookingModal(); // Fermer le modal actuel
                  // Ouvrir le modal des réservations clients pour la date sélectionnée
                  fetchReservationsForDate(selectedDate, selectedDayBookings);
                }}
              >
                Réservations client
              </Button>
            }
          </Modal.Footer>
        </Modal>

        {/* Modal de réservation */}
        <Modal show={showReservationModal} onHide={handleFermerReservationModal} centered>
          <Modal.Header>
            <Modal.Title>
              Confirmer votre réservation
            </Modal.Title>
          </Modal.Header>

          {alertModal.message && (
            <div className={`m-3 alert alert-${alertModal.type}`}>
              {alertModal.message}
            </div>
          )}
          <Modal.Body className="p-4">
            {selectedBookingItem && (
              <>
                {/* Récapitulatif du booking */}
                <Card className="mb-4 border-0 bg-light">
                  <Card.Body>
                    <h6 className="fw-bold mb-2">Détails du booking</h6>
                    <div className="d-flex justify-content-between">
                      <div>
                        <small className="text-muted">Booking:</small>
                        <p className="mb-1 fw-bold">{selectedBookingItem.bookingTitle}</p>
                      </div>
                      <div>
                        <small className="text-muted">Date:</small>
                        <p className="mb-1 fw-bold">{selectedDate.format('DD/MM/YYYY')}</p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div>
                        <small className="text-muted">Horaire:</small>
                        <p className="mb-0 fw-bold">{selectedBookingItem.heure_deb} - {selectedBookingItem.heure_fin}</p>
                      </div>
                      <div>
                        <small className="text-muted">Type:</small>
                        <p className="mb-0 fw-bold">
                          {selectedBookingItem.type_crenau === 'en_ligne' ? 'Virtuel' : 'Présentiel'}
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>

                {/* SECTION DES CONDITIONS D'ANNULATION */}
                {user_id &&
                  <Card className="mb-4 border-warning">
                    <Card.Body className="p-3">
                      <div className="d-flex align-items-start">
                        <div>
                          <h6 className="fw-bold text-warning mb-2">Conditions d'annulation</h6>
                          <ul className="list-unstyled mb-0 small">
                            <li className="mb-1">
                              <FaClock className="text-muted mr-1" size={12} />
                              <strong>Délai d'annulation :</strong> Jusqu'à 24 heures avant le début du booking
                            </li>
                            <li className="mb-1">
                              <FaTimes className="text-muted mr-1" size={12} />
                              <strong>Après ce délai :</strong> L'annulation n'est plus possible
                            </li>
                          </ul>
                          <div className="mt-2 p-2 bg-light rounded">
                            <small className="text-muted">
                              <strong>Exemple :</strong> Pour un booking à 14h00, vous pouvez annuler jusqu'à 14h00 la veille.
                            </small>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                }

                {/* Formulaire de réservation */}
                {!user_id &&
                  <Form>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Nom <span className='text-danger'>*</span></Form.Label>
                          <Form.Control
                            type="text"
                            value={reservationData.nom}
                            onChange={(e) => setReservationData({ ...reservationData, nom: e.target.value })}
                            placeholder="Votre nom"
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Prénom <span className='text-danger'>*</span></Form.Label>
                          <Form.Control
                            type="text"
                            value={reservationData.prenom}
                            onChange={(e) => setReservationData({ ...reservationData, prenom: e.target.value })}
                            placeholder="Votre prénom"
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label>Email <span className='text-danger'>*</span></Form.Label>
                      <Form.Control
                        type="email"
                        value={reservationData.email}
                        onChange={(e) => setReservationData({ ...reservationData, email: e.target.value })}
                        placeholder="votre@email.com"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Téléphone <span className='text-danger'>*</span></Form.Label>
                      <Form.Control
                        type="tel"
                        value={reservationData.telephone}
                        onChange={(e) => setReservationData({ ...reservationData, telephone: e.target.value })}
                        placeholder="Votre numéro de téléphone"
                        required
                      />
                    </Form.Group>
                  </Form>
                }
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="outline-secondary"
              onClick={handleFermerReservationModal}
              disabled={isSubmitting}
            >
              Annuler
            </Button>
            {isSubmitting ? (
              <Button variant="success" disabled>
                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                Réservation en cours...
              </Button>
            ) : (
              <Button className='d-flex justify-content-center align-items-center' variant="success" onClick={handleReservation}>
                <FaCalendarAlt className="mr-1" />
                Confirmer la réservation
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmation pour annuler une réservation */}
        <Modal show={showCancelModal} onHide={() => {
          setShowCancelModal(false);
          setAnnulationMotif('');
        }} centered>
          <Modal.Header>
            <Modal.Title>
              Annuler la réservation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div>
              <p className="text-muted">
                Êtes-vous sûr de vouloir annuler votre réservation ?
              </p>

              {/* Champ pour le motif d'annulation */}
              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Motif d'annulation <span className='text-danger'>*</span></strong>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={annulationMotif}
                  onChange={(e) => setAnnulationMotif(e.target.value)}
                  placeholder="Veuillez saisir le motif de l'annulation..."
                  required
                />
              </Form.Group>

              {/* Avertissement si proche du début */}
              {selectedReservation && !canCancelReservation(selectedReservation) && (
                <Alert variant="danger" className="mt-3">
                  {/* <FaExclamationTriangle className="mr-2" /> */}
                  <strong>Attention :</strong> Cette réservation commence dans moins de 24 heures.
                  L'annulation n'est plus possible à ce stade.
                </Alert>
              )}

              <div className="bg-light p-3 rounded mt-3">
                <div className="row text-start">
                  <div className="col-6">
                    <strong>Booking :</strong><br />
                    {selectedReservation?.booking_title}
                  </div>
                  <div className="col-6">
                    <strong>Créneau :</strong><br />
                    <span>{selectedReservation && moment(selectedReservation.date).format('DD/MM/YYYY')} de </span>
                    <span>{selectedReservation?.heure_deb} à {selectedReservation?.heure_fin}</span>
                  </div>
                </div>

                {/* Affichage du temps restant */}
                {/* {selectedReservation && (
                  <div className="mt-2">
                    <small className="text-muted">
                      <strong>Temps restant : </strong>
                      {(() => {
                        const reservationDateTime = moment(`${selectedReservation.date} ${selectedReservation.heure_deb}`, 'YYYY-MM-DD HH:mm');
                        const now = moment();
                        const duration = moment.duration(reservationDateTime.diff(now));

                        if (duration.asHours() < 1) {
                          return `${Math.floor(duration.asMinutes())} minutes`;
                        } else {
                          return `${Math.floor(duration.asHours())}h ${duration.minutes()}min`;
                        }
                      })()}
                    </small>
                  </div>
                )} */}
              </div>

              <p className="text-muted small mt-3">
                <strong>NB :</strong> La place sera à nouveau disponible.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setShowCancelModal(false);
              setAnnulationMotif('');
            }} disabled={isChargement}>
              Garder la réservation
            </Button>
            <button
              className={`btn ${(isChargement || (selectedReservation && !canCancelReservation(selectedReservation)) || !annulationMotif.trim()) ? 'btn-default' : 'btn-success'}`}
              onClick={handleCancelAction}
              disabled={isChargement || (selectedReservation && !canCancelReservation(selectedReservation)) || !annulationMotif.trim()}
            >
              {isChargement ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                  Annulation...
                </>
              ) : (
                <>
                  <FaTimes className="mr-1" />
                  Annuler la réservation
                </>
              )}
            </button>
          </Modal.Footer>
        </Modal>

        <Modal show={showHelpModal} onHide={() => setShowHelpModal(false)} centered size="lg">
          <Modal.Header className="bg-primary text-white">
            <Modal.Title>
              Guide de réservation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="help-content">
              <div className="mb-4">
                <h5 className="text-primary mb-3">Comment réserver un booking ?</h5>
                <ul className="list-unstyled mb-0">
                  <li className="d-flex align-items-center mb-3">
                    <div className="step-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3 mr-2"
                      style={{ width: '28px', height: '28px', fontSize: '14px', fontWeight: 'bold', flexShrink: 0 }}>
                      1
                    </div>
                    <div>
                      <strong>Cliquez sur une date</strong> dans le calendrier pour voir les bookings disponibles
                    </div>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <div className="step-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3 mr-2"
                      style={{ width: '28px', height: '28px', fontSize: '14px', fontWeight: 'bold', flexShrink: 0 }}>
                      2
                    </div>
                    <div>
                      <strong>Sélectionnez un booking</strong> dans la liste qui s'affiche
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="step-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3 mr-2"
                      style={{ width: '28px', height: '28px', fontSize: '14px', fontWeight: 'bold', flexShrink: 0 }}>
                      3
                    </div>
                    <div>
                      <strong>Confirmez votre réservation</strong>{!user_id && ' en remplissant vos informations'}
                    </div>
                  </li>
                </ul>
              </div>

              <div className="mb-4">
                <h5 className="text-success mb-3">Consulter mes réservations</h5>
                <div className="d-flex align-items-center mb-2">
                  <FaStar className="text-success mr-1" />
                  <div>
                    <strong>Onglet "Mes Réservations"</strong> - Visualisez toutes vos réservations confirmées
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <FaVideo className="text-info mr-1" />
                  <div>
                    <strong>Lien Teams</strong> - Pour les bookings virtuel, cliquez sur l'icône vidéo pour rejoindre
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h5 className="text-warning mb-3">Annuler une réservation</h5>
                <div className="d-flex align-items-center mb-2">
                  <FaExclamationTriangle className="text-warning mr-1" />
                  <div>
                    <strong>Délai de 24 heures</strong> - Annulation possible jusqu'à 24h avant le booking
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <FaTimes className="text-danger mr-1" />
                  <div>
                    <strong>Bouton "Annuler"</strong> - Disponible sur chaque réservation annulable
                  </div>
                </div>
              </div>

              <Alert variant="info" className="mt-4">
                <strong>Important :</strong> Toutes les heures sont affichées en (UTC+01:00) West Central Africa
              </Alert>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => setShowHelpModal(false)}>
              J'ai compris !
            </Button>
          </Modal.Footer>
        </Modal>


        {userHasAccess("Administration") && renderCoachBookingModal()}

        <style>{`
          .calendar-container {
            background: white;
            border-radius: 12px;
            padding: 0;
            overflow: hidden;
            border: 1px solid #e5e7eb;
          }

          .btn-tab {
            border: none;
            border-bottom: 3px solid transparent;
            border-radius: 0;
            padding: 10px 20px;
            color: #6c757d;
            background: transparent;
            transition: all 0.3s ease;
          }

          .btn-tab.active {
            color: #0d6efd;
            border-bottom-color: #0d6efd;
            background-color: rgba(13, 110, 253, 0.05);
          }

          .btn-tab:hover {
            color: #0d6efd;
            background-color: rgba(13, 110, 253, 0.05);
          }

          .btn {
            border-radius: 8px;
            font-weight: 500;
            transition: all 0.2s ease;
          }

          .btn-outline-secondary {
            border-color: #e5e7eb;
          }

          .btn-outline-secondary:hover {
            background-color: #f8fafc;
            border-color: #d1d5db;
          }

          .card {
            border-radius: 12px;
            overflow: hidden;
            background: white;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          }

          .badge {
            border-radius: 12px;
            font-weight: 500;
          }

          .fs-8 {
            font-size: 0.7rem;
          }

          /* Styles pour le filtre des réservations */
          .reservations-container .form-select {
            border-radius: 8px;
            border: 1px solid #e5e7eb;
          }

          .reservations-container .badge.cursor-pointer {
            cursor: pointer;
          }

          /* Amélioration de l'affichage des cartes de réservation */
          .reservation-card {
            transition: all 0.2s ease;
          }

          .reservation-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }

          /* FullCalendar personnalisation */
          .fc {
            font-family: inherit;
          }

          .fc-toolbar {
            padding: 1rem;
          }

          .fc-toolbar-title {
            font-size: 1.5rem;
            font-weight: 600;
            color: #374151;
          }

          .fc-button {
            background-color: #f8fafc;
            border: 1px solid #e5e7eb;
            color: #374151;
            font-weight: 500;
            border-radius: 6px;
            padding: 0.5rem 1rem;
          }

          .fc-button:hover {
            background-color: #f1f5f9;
            border-color: #d1d5db;
          }

          .fc-button-active {
            background-color: #0ea5e9;
            border-color: #0ea5e9;
            color: white;
          }

          .fc-daygrid-day-number {
            font-weight: 500;
            color: #374151;
          }

          .fc-day-today {
            background-color: #fff8e1 !important;
          }

          .fc-event {
            border: none;
            border-radius: 6px;
            padding: 2px 4px;
            font-size: 0.8rem;
            font-weight: 500;
            cursor: pointer;
          }

          .fc-event:hover {
            opacity: 0.9;
            transform: translateY(-1px);
            transition: all 0.2s ease;
          }
        `}</style>

        
                  <style>{`
      /* Styles pour le carousel mobile */
      .linkedin-carousel-container {
        position: relative;
        overflow: hidden;
        border-radius: 16px;
      }

      .carousel-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(255, 255, 255, 0.9);
        color: #0a66c2;
        border: none;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        cursor: pointer;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
      }

      .carousel-arrow:hover {
        background: white;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        transform: translateY(-50%) scale(1.1);
      }

      .carousel-arrow-left {
        left: 10px;
      }

      .carousel-arrow-right {
        right: 10px;
      }

      .linkedin-carousel-track::-webkit-scrollbar {
        height: 6px;
      }

      .linkedin-carousel-track::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }

      .linkedin-carousel-track::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;
      }

      .linkedin-carousel-track::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
      }

      .carousel-indicator.active {
        background-color: #0a66c2 !important;
      }

      .carousel-indicator:hover {
        background-color: #0a66c2 !important;
      }

      /* Styles pour le scroll desktop */
      .desktop-linkedin-feed::-webkit-scrollbar {
        width: 6px;
      }

      .desktop-linkedin-feed::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }

      .desktop-linkedin-feed::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;
      }

      .desktop-linkedin-feed::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
      }

      /* Amélioration du responsive */
      @media (max-width: 768px) {
        .linkedin-carousel-item {
          flex: 0 0 80% !important;
          min-width: 80% !important;
        }
        
        .carousel-arrow {
          width: 35px;
          height: 35px;
        }
      }

      @media (max-width: 576px) {
        .linkedin-carousel-item {
          flex: 0 0 85% !important;
          min-width: 85% !important;
        }
        
        .linkedin-carousel-item iframe {
          height: 450px !important;
        }
      }
    `}</style>
      </div>
    </div>
  );
};

export default PriseRendezVousClient;